import { useState } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import DefaultNavbarDropdown from 'examples/Navbars/DefaultNavbar/DefaultNavbarDropdown';

function DefaultNavbarMobile({ routes, open, closeHandler, onScrollTo }) {
  const [collapse, setCollapse] = useState('');

  const handleSetCollapse = (name) => (collapse === name ? setCollapse(false) : setCollapse(name));

  const renderNavbarItems = routes.map(
    ({ name, icon, collapse: routeCollapses, scrollToId, href, collapse: navCollapse }) => (
      <DefaultNavbarDropdown
        key={name}
        name={name}
        // icon={icon}
        collapseStatus={name === collapse}
        onClick={() => {
          if (href) {
            window.open(href, '_blank');
            closeHandler();
          } else if (scrollToId) {
            onScrollTo(scrollToId);
          } else {
            handleSetCollapse(name);
          }
        }}
        collapse={Boolean(navCollapse)}
      >
        <MKBox sx={{ height: '15rem', maxHeight: '15rem', overflowY: 'scroll' }}>
          {routeCollapses &&
            routeCollapses.map((item) => (
              <MKBox key={item.name} px={2}>
                {item.collapse ? (
                  <>
                    <MKTypography
                      display="block"
                      variant="button"
                      fontWeight="bold"
                      textTransform="capitalize"
                      py={1}
                      px={0.5}
                    >
                      {item.name}
                    </MKTypography>
                    {item.collapse.map((el) => (
                      <MKTypography
                        key={el.name}
                        component={MKBox}
                        minWidth="11.25rem"
                        display="block"
                        variant="button"
                        color="text"
                        textTransform="capitalize"
                        fontWeight="regular"
                        py={0.625}
                        px={2}
                        sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                          borderRadius: borderRadius.md,
                          cursor: 'pointer',
                          transition: 'all 300ms linear',
                          '&:hover': {
                            backgroundColor: grey[200],
                            color: dark.main,
                          },
                        })}
                        onClick={(e) => {
                          e.preventDefault();
                          if (el.scrollToId) {
                            onScrollTo(el.scrollToId);
                          } else if (el.href) {
                            window.open(el.href, '_blank');
                            closeHandler();
                          }
                        }}
                      >
                        {el.name}
                      </MKTypography>
                    ))}
                  </>
                ) : (
                  <MKBox
                    key={item.key || item.name}
                    display="block"
                    component={MKBox}
                    sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                      borderRadius: borderRadius.md,
                      cursor: 'pointer',
                      transition: 'all 300ms linear',
                      py: 1,
                      px: 1.625,
                      '&:hover': {
                        backgroundColor: grey[200],
                        color: dark.main,
                        '& *': {
                          color: dark.main,
                        },
                      },
                    })}
                    onClick={(e) => {
                      e.preventDefault();
                      if (item.scrollToId) {
                        onScrollTo(item.scrollToId);
                      } else if (item.href) {
                        window.open(item.href, '_blank');
                        closeHandler();
                      }
                    }}
                  >
                    <MKTypography
                      display="block"
                      variant="button"
                      fontWeight="bold"
                      textTransform="capitalize"
                    >
                      {item.name}
                    </MKTypography>
                  </MKBox>
                )}
              </MKBox>
            ))}
        </MKBox>
      </DefaultNavbarDropdown>
    )
  );

  return (
    <Collapse in={Boolean(open)} timeout="auto" unmountOnExit>
      <MKBox width="calc(100% + 1.625rem)" my={2} ml={-2}>
        {renderNavbarItems}
      </MKBox>
    </Collapse>
  );
}

DefaultNavbarMobile.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  closeHandler: PropTypes.func.isRequired,
  onScrollTo: PropTypes.func.isRequired,
};

export default DefaultNavbarMobile;
